export const SEVERITY = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFORMATIVE: 'informative',
} as const;

export type Severity = (typeof SEVERITY)[keyof typeof SEVERITY];

export const SEVERITY_TEXT_COLOR: Record<Severity, string> = {
  success: 'text-text-success',
  warning: 'text-text-warning',
  error: 'text-text-error',
  informative: 'text-text-info',
};

export const SEVERITY_BG_COLOR: Record<Severity, string> = {
  success: 'bg-bg-success',
  warning: 'bg-bg-warning',
  error: 'bg-bg-error',
  informative: 'bg-bg-info',
};

export const SEVERITY_COLOR_CSS_VAR: Record<Severity, string> = {
  success: 'var(--color-green-500)',
  warning: 'var(--color-orange-500)',
  error: 'var(--color-red-500)',
  informative: 'var(--color-blue-500)',
};

export const SEVERITY_COLOR_HEX: Record<Severity, string> = {
  success: '#22c55e',
  warning: '#f97316',
  error: '#ef4444',
  informative: '#3b82f6',
};

export const errorSeverityWhen = (condition: boolean): Severity | undefined =>
  condition ? SEVERITY.ERROR : undefined;

export const SEVERITY_SURFACE_STYLES: Record<Severity, string> = {
  error: 'bg-bg-error-subtler border-border-error',
  warning: 'bg-bg-warning-subtler border-border-warning',
  success: 'bg-bg-success-subtler border-border-success',
  informative: 'bg-bg-info-subtler border-border-info',
};
